import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-page"
}
const _hoisted_2 = {
  key: 1,
  class: "admin-page"
}

import {onMounted, ref} from 'vue';
	import {useRouter} from 'vue-router';
	import SelectSeason from '../components/SelectSeason.vue';
	import ModalWindow from '../components/ModalWindow.vue';
	import {FetchData} from "../utils/FetchData";
	import FetchOptions from '../interfaces/FetchOptions';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminPage',
  setup(__props) {

	const selectingSeason = ref(false);
	const router = useRouter();

	const modalVisible = ref(false);
	const deletingSeason = ref({});

	onMounted(() => {
		router.replace('/admin');
	});

	function seasonAdd() {
		router.push({path: '/admin/edit'});
	}

	function seasonEdit() {
		selectingSeason.value = true;
		router.push({path: '/admin', hash:'#edit'});
	}

	function seasonDelete() {
		selectingSeason.value = true;
		router.push({path: '/admin', hash: '#delete'});
	}

	function seasonSelected(season: object) {
		if(router.currentRoute.value.hash == '#delete') {
			deletingSeason.value = season;
			modalVisible.value = true;
		}
		else if(router.currentRoute.value.hash == '#edit') {
			deletingSeason.value = season;
			router.replace({path: '/admin/edit', query: {id: season.id}});
		}
	}

	function goBack() {
		deletingSeason.value = {};
		router.back();
	}

	router.beforeEach((to) => {
		if(to.hash == '#edit' || to.hash == '#delete') {
			selectingSeason.value = true;
			return true;
		}
		else {
			selectingSeason.value = false;
			return true;
		}
	});

	async function confirmAccept() {
		modalVisible.value = false;

		const options: FetchOptions = {
			method: 'DELETE'
		};
		const data = await FetchData("seasons/" + deletingSeason.value.id, options);
		if(!data.isError)
			router.back();
	}

	function confirmDeny() {
		modalVisible.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!selectingSeason.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "content-box",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (seasonAdd()))
          }, " Seizoen Toevoegen "),
          _createElementVNode("button", {
            class: "content-box",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (seasonEdit()))
          }, " Seizoen Aanpassen "),
          _createElementVNode("button", {
            class: "content-box",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (seasonDelete()))
          }, " Seizoen Verwijderen ")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "content-box",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (goBack()))
          }, " Terug "),
          _createVNode(SelectSeason, { onSeasonClicked: seasonSelected })
        ])),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Bevestigen ")
      ]),
      content: _withCtx(() => [
        _createTextVNode(" Weet je zeker dat je seizoen '" + _toDisplayString(deletingSeason.value.name) + "' en alle bijbehorende gegevens wilt verwijderen? ", 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: confirmAccept }, "Ja"),
        _createElementVNode("button", { onClick: confirmDeny }, "Nee")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalVisible.value]
    ])
  ], 64))
}
}

})